import { BackendHttpService } from "../backendHttpService";

export interface CertificationFamilyMemberModel {
    id: number;
    title: string;
}

export interface CertificationFamilyDictionaryModel {
    id: number;
    name: string;
    description: string | null;
    certificationCount: number;
    /**
     * Member certificates of this family. Added for FS_05_Reporting_01's "By Certificates"
     * report — picking a family shows this list as a preview before adding its members as
     * individual chips. The backend (`GetCertificationFamiliesQueryHandler`) already returns
     * this; earlier callers (Talent Marketplace's `SkillRequirementSelector`) only needed the
     * count, so it was previously discarded here rather than fetched again separately.
     */
    certifications: CertificationFamilyMemberModel[];
}

export class CertificationFamilyDictionaryService extends BackendHttpService {
    private cache: CertificationFamilyDictionaryModel[] | null = null;

    constructor() {
        super("dictionary");
    }

    async getCertificationFamilies(): Promise<CertificationFamilyDictionaryModel[]> {
        if (this.cache) {
            return this.cache;
        }
        const raw = await this.get<Array<{
            id: number;
            name: string;
            description: string | null;
            certificationCount: number;
            certifications: Array<{ id: number; title: string }>;
        }>>("/certification-families");
        this.cache = raw.map((f) => ({
            id: f.id,
            name: f.name,
            description: f.description,
            certificationCount: f.certificationCount,
            certifications: f.certifications ?? [],
        }));
        return this.cache;
    }

    clearCache(): void {
        this.cache = null;
    }
}

export const certificationFamilyDictionaryService = new CertificationFamilyDictionaryService();
